<template>
  <v-dialog
    :value="value"
    fullscreen
    hide-overlay
    content-class="aviso-visor-dlg"
    transition="dialog-bottom-transition"
    @input="$emit('input', $event)"
  >
    <div v-if="actual" class="aviso-visor">
      <div class="aviso-visor__bar">
        <v-btn icon dark aria-label="Cerrar visor" @click="cerrar">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <div class="aviso-visor__info">
          <strong>{{ aviso.nombre }}</strong>
          <span>{{ fechaCreacion(aviso) }} · {{ idx + 1 }} de {{ lista.length }}</span>
        </div>
        <v-btn
          icon
          dark
          :href="actual.url_descarga || actual.url"
          :download="actual.nombre"
          target="_blank"
          aria-label="Descargar imagen"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <v-btn icon dark aria-label="Cerrar" @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="aviso-visor__stage" @click.self="cerrar">
        <v-btn
          v-if="idx > 0"
          icon
          large
          dark
          class="aviso-visor__nav aviso-visor__nav--prev"
          aria-label="Imagen anterior"
          @click="mover(-1)"
        >
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
        <img :src="actual.url" :alt="actual.nombre" />
        <v-btn
          v-if="idx < lista.length - 1"
          icon
          large
          dark
          class="aviso-visor__nav aviso-visor__nav--next"
          aria-label="Imagen siguiente"
          @click="mover(1)"
        >
          <v-icon large>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
      <div
        v-if="aviso.descripcion"
        class="aviso-visor__pie"
        :style="{ visibility: expandido ? 'hidden' : 'visible' }"
      >
        <p ref="texto" class="aviso-visor__txt">{{ aviso.descripcion }}</p>
        <button v-if="largo" type="button" class="aviso-visor__mas" @click="expandido = true">
          ver más
        </button>
      </div>
      <transition name="aviso-visor-fade">
        <div v-if="expandido" class="aviso-visor__velo" @click.self="expandido = false">
          <div class="aviso-visor__full">
            <p>{{ aviso.descripcion }}</p>
            <button type="button" class="aviso-visor__mas" @click="expandido = false">
              ver menos
            </button>
          </div>
        </div>
      </transition>
    </div>
  </v-dialog>
</template>

<script>
import { archivosDe, fechaCreacion } from "../../utils/avisos.js";

// Visor de imagenes de un aviso a pantalla completa (estilo WhatsApp)
export default {
  name: "VisorImagenes",
  props: {
    value: { type: Boolean, default: false },
    aviso: { type: Object, default: null },
    index: { type: Number, default: 0 },
  },
  data: () => ({ idx: 0, expandido: false, largo: false }),
  computed: {
    lista() {
      return archivosDe(this.aviso).filter((a) => a.es_imagen && a.url);
    },
    actual() {
      return this.aviso ? this.lista[this.idx] : null;
    },
  },
  watch: {
    value(abierto) {
      this.expandido = false;
      if (abierto) {
        this.idx = Math.max(0, Math.min(this.index, this.lista.length - 1));
        this.medir();
      }
      const f = abierto ? "addEventListener" : "removeEventListener";
      window[f]("keydown", this.tecla);
    },
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.tecla);
  },
  methods: {
    fechaCreacion,
    // Muestra "ver mas" solo si el texto no entra en las 2 lineas del pie
    medir() {
      setTimeout(() => {
        const e = this.$refs.texto;
        this.largo = !!e && e.scrollHeight > e.clientHeight + 1;
      }, 80);
    },
    cerrar() {
      this.$emit("input", false);
    },
    mover(d) {
      const n = this.idx + d;
      if (n >= 0 && n < this.lista.length) this.idx = n;
    },
    tecla(e) {
      if (e.key === "ArrowLeft") this.mover(-1);
      else if (e.key === "ArrowRight") this.mover(1);
    },
  },
};
</script>

<style>
.aviso-visor-dlg { z-index: 2000 !important; }
.aviso-visor { display: flex; flex-direction: column; height: 100%; background: #0b141a; color: #e9edef; }
.aviso-visor__bar { display: flex; align-items: center; gap: 8px; padding: 8px 12px; background: #111b21; }
.aviso-visor__info { flex: 1; min-width: 0; display: flex; flex-direction: column; text-align: left; }
.aviso-visor__info strong { font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.aviso-visor__info span { font-size: 0.78rem; color: #8696a0; }
.aviso-visor__stage { position: relative; flex: 1; min-height: 0; display: flex; align-items: center; justify-content: center; padding: 12px 56px; }
.aviso-visor__stage img { width: 100%; height: 100%; object-fit: contain; }
.aviso-visor__nav { position: absolute !important; top: 50%; transform: translateY(-50%); background: rgba(255, 255, 255, 0.12) !important; }
.aviso-visor__nav--prev { left: 12px; }
.aviso-visor__nav--next { right: 12px; }
.aviso-visor { position: relative; }
.aviso-visor__pie { display: flex; align-items: baseline; justify-content: center; gap: 8px; padding: 12px 20px 18px; font-size: 0.9rem; color: #e9edef; background: #111b21; }
.aviso-visor__txt { margin: 0; max-width: 720px; text-align: left; line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; word-break: break-word; }
.aviso-visor__mas { flex-shrink: 0; padding: 0; border: 0; background: none; color: #53bdeb; font-size: 0.9rem; cursor: pointer; }
.aviso-visor__mas:hover { text-decoration: underline; }
.aviso-visor__velo { position: absolute; inset: 0; z-index: 5; display: flex; align-items: flex-end; justify-content: center; background: rgba(11, 20, 26, 0.78); }
.aviso-visor__full { width: 100%; max-width: 720px; max-height: 70%; overflow: auto; padding: 24px 24px 28px; text-align: left; font-size: 0.95rem; line-height: 1.5; white-space: pre-line; word-break: break-word; }
.aviso-visor__full p { margin: 0 0 12px; }
.aviso-visor-fade-enter-active, .aviso-visor-fade-leave-active { transition: opacity 0.2s; }
.aviso-visor-fade-enter, .aviso-visor-fade-leave-to { opacity: 0; }
</style>
